import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditWorkLocationsReady} from '../redux/workLocations'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'

//import * as Helpers from '../../../common/helpers'



import {Cities,EntityType} from '../../../common/DropDowns/index'

class AddEditWorkLocations extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        editFlag:false,

        workLocationsName: "",
        workLocationsType: "",
        cityId: "",
        address: "",


        workLocationsNameErrorText: false,
        workLocationsNameErrorData: '',

        workLocationsTypeErrorText: false,
        workLocationsTypeErrorData: '',

        cityIdErrorText: false,
        cityIdErrorData: '',

        addressErrorText: false,
        addressErrorData: '',

        subTitle: Constants.ADD_WORKLOCATION

    }

    this.isComponentStillMounted = true

    this.workLocationsNameComponent = null
    this.workLocationsNameSection = null


    this.workLocationsTypeComponent = null
    this.workLocationsTypeSection = null

    this.cityIdComponent = null
    this.cityIdSection = null

    this.addressComponent = null
    this.addressSection = null


}

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addEditWorkLocationsReady(false))

    if (this.props.workLocations && this.props.workLocations.workLocationsSelectedId && this.props.workLocations.workLocationsSelectedId !== null) {
        this.props.dispatch(headerDataUpdate(Constants.EDIT_WORKLOCATION))
        this.setState({
            subTitle: "Edit Work Location",
            editFlag:true
        })
    } else {
        this.props.dispatch(headerDataUpdate(Constants.ADD_WORKLOCATION))
        this.setState({
            subTitle: "Add Work Location"
        })
    }
    this.props.dispatch(subHeaderDataUpdate())

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()


    if (this.props.workLocations && this.props.workLocations.workLocationsSelectedId && this.props.workLocations.workLocationsSelectedId !== null) {
        this.getWorkLocationsById(this.props.workLocations.workLocationsSelectedId)
    }else{

    this.props.dispatch(addEditWorkLocationsReady(true))
    }
}

 workLocationsTypeChange = (data) => {
    this.workLocationsTypeComponent.value=data.value
        this.setState({
            workLocationsType :data.value,
            workLocationsTypeErrorText: false,
            workLocationsTypeErrorData: ''
        })
        this.workLocationsTypeSection.className= this.workLocationsTypeSection.className.replace(" has-error", "")
    }


    
        
         cityChange = (data) => {
    this.cityIdComponent.value=data.value
        this.setState({
            cityId :data.value,
            cityIdErrorText: false,
            cityIdErrorData: ''
        })
        this.cityIdSection.className= this.cityIdSection.className.replace(" has-error", "")
    }
        

componentDidMount() {

        this.workLocationsNameSection = ReactDOM.findDOMNode(this.refs.workLocationsNameSection)
        this.workLocationTypeComponent = ReactDOM.findDOMNode(this.refs.workLocationTypeComponent)
        this.cityIdSection = ReactDOM.findDOMNode(this.refs.cityIdSection)
        this.addressSection = ReactDOM.findDOMNode(this.refs.addressSection)

}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 100) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

onSaveClick = () => {

    this.props.dispatch(addEditWorkLocationsReady(false))
    let data = {}

    let workLocationsNameObject = this.mandateValidation("workLocationsName", Constants.FORM_INPUT)
    if (workLocationsNameObject.status) {
        data.name = this.workLocationsNameComponent.value
    } else {

        this.props.dispatch(addEditWorkLocationsReady(true))
        return
    }

    let workLocationsTypeObject = this.mandateValidation("workLocationsType", Constants.FORM_SELECT)
    if (workLocationsTypeObject.status) {
        data.type = this.workLocationsTypeComponent.value
    } else {

        this.props.dispatch(addEditWorkLocationsReady(true))
        return
    }

    let cityIdObject = this.mandateValidation("cityId", Constants.FORM_SELECT)
    if (cityIdObject.status) {
        data.city_id = this.cityIdComponent.value
    } else {

        this.props.dispatch(addEditWorkLocationsReady(true))
        return
    }

    data.address=this.addressComponent.value



    let apiPayloadData=data;


    if(this.state.editFlag){


        apiService.editWorkLocations(apiPayloadData,this.state.workLocationsData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditWorkLocationsReady(true))
                        this.props.history.push("/dashboard/workLocations/list")
                    } else {

                        this.props.dispatch(addEditWorkLocationsReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditWorkLocationsReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }else{

    apiService.addWorkLocations(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditWorkLocationsReady(true))
                        this.props.history.push("/dashboard/workLocations/list")
                    } else {

                        this.props.dispatch(addEditWorkLocationsReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditWorkLocationsReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }


}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}


getWorkLocationsById = (id) => {
    apiService.getWorkLocationsById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

                if (responseData && responseData.data) {                   
                    this.setState({
                        workLocationsData: responseData.data ,
                        workLocationsName : responseData.data.name,
                        workLocationsType : responseData.data.type,
                        cityId : responseData.data.city_id,
                        address : responseData.data.address            
                    })

                    if (this.isComponentStillMounted) {
                        this.workLocationsNameComponent.value=responseData.data.name
                        this.workLocationsTypeComponent.value=responseData.data.type
                        this.cityIdComponent.value=responseData.data.city_id
                        this.addressComponent.value=responseData.data.address
                    }


                    this.props.dispatch(addEditWorkLocationsReady(true))             

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditWorkLocationsReady(true))
        })
}








    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.workLocationsNameSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Name *</label>
                                                    <div className="col-sm-9">
                                                        <input className="form-control" placeholder="Enter Work Location Name" type="text" ref={el => this.workLocationsNameComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("workLocationsName")}} />
                                                        <span className="help-block"style={{display: this.state.workLocationsNameErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.workLocationsNameErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                             <div className="col-md-6 col-sm-12 col-xs-12">
                                                    <div className="form-group" ref={el => this.workLocationsTypeSection = el}>
                                                        <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Type *</label>
                                                        <div className="col-sm-9" ref={el => this.workLocationsTypeComponent = el}>
                                                            
                                                             <EntityType entityTypeChange={this.workLocationsTypeChange} selectedValue={this.state.workLocationsType} type="WORK_LOCATIONS" />

                                                            <span className="help-block"style={{display: this.state.workLocationsTypeErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                                {this.state.workLocationsTypeErrorData}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                             <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.cityIdSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>City *</label>
                                                    <div className="col-sm-9" ref={el => this.cityIdComponent = el}>
                                                        
                                                         <Cities cityChange={this.cityChange} selectedValue={this.state.cityId} />

                                                        <span className="help-block"style={{display: this.state.cityIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.cityIdErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>


                                       
                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                         <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el => this.addressSection = el}>
                                                                <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Address</label>
                                                                <div className="col-sm-9">
                                                                    <textarea  style={{resize:"none"}} className="form-control" placeholder="Type address...." reason="text" ref={el => this.addressComponent = el}
                                                                        onChange={(e) => {e.preventDefault() 
                                                                        this.keyedInputChange("address")}} />
                                                                    <span className="help-block"style={{display: this.state.addressErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                                        {this.state.addressErrorData}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                    
                                            </div>

                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>

                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        workLocations: state.workLocations,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditWorkLocations))


// WEBPACK FOOTER //
// ./src/modules/Work Locations/Components/AddEditWorkLocations.js